export default {
  name: "XcpOpsManager",
  computed: {
    key: function key() {
      return this.$route.fullPath;
    }
  }
};